define('plugins/musicfavourite/adapter/idAvailability',["require", "exports", "jquery-1.9", "./knownErrors"], function (require, exports, $, Errors) {
    "use strict";
    exports.__esModule = true;
    function isIdAvailable() {
        return window.MUSICFAV_idIsAvailable;
    }
    exports.isIdAvailable = isIdAvailable;
    function ajaxIfIdAvailable(settings) {
        return isIdAvailable()
            ? $.ajax(settings)
            : $.Deferred().reject(Errors.IdUnavailable);
    }
    exports.ajaxIfIdAvailable = ajaxIfIdAvailable;
});
//# sourceMappingURL=idAvailability.js.map;
